<template>
  <v-flex>
    <h3>Pagina no encontrada</h3>
    <v-btn flat color="primary" to="/">Home</v-btn>
  </v-flex>
</template>

<script>
export default {};
</script>